import styled, { css } from 'styled-components'

export const Container = styled.div`
    padding: 1rem 0;

    label{
        font-weight: 500;
        font-size: 1.2rem;
        margin-bottom: 0.2rem;
    }

    input{
        width: 100%;
        border: none;
        border: 1.5px solid #7A05A7;
        border-radius: 5px;
        padding: 0.7rem;
        margin-bottom: 1.5rem;
    }

    ${props => (props.changeVisibleContent !== 0) && css`
        display: none;
    `}
`


